import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ReferralCapture = () => {
  const location = useLocation();

  useEffect(() => {
    const code = new URLSearchParams(location.search).get("ref");
    if (/^[A-Za-z0-9-]{4,15}$/.test(code || "")) {
      localStorage.setItem("tco_referral_code", code.toUpperCase());
    }
  }, [location.search]);

  return null;
};